import harshDrivingChime from "../../../../../assets/wav/harshDrivingChime.wav";
import harshDriving from "../../../../../assets/wav/harshDriving.wav";
import powerChime from "../../../../../assets/wav/powerChime.wav";
import powerOff from "../../../../../assets/wav/powerOff.wav";
import FCW_alert from "../../../../../assets/wav/FCW_alert.wav";
import headway from "../../../../../assets/wav/headway.wav";
import headwayChime from "../../../../../assets/wav/headwayChime.wav";
import tailgatingChime from "../../../../../assets/wav/tailgatingChime.wav";
import tailgating from "../../../../../assets/wav/tailgating.wav";
import distractionDetected from "../../../../../assets/wav/distractionDetected.wav";
import distractionChime from "../../../../../assets/wav/distractionChime.wav";
import noSeatbeltChime from "../../../../../assets/wav/noSeatbeltChime.wav";
import noSeatbeltDetected from "../../../../../assets/wav/noSeatbeltDetected.wav";
import cameraObstructed from "../../../../../assets/wav/cameraObstructed.wav";
import cameraObstructedChime from "../../../../../assets/wav/cameraObstructedChime.wav";

// Note: "harsh driving" applies to harsh accel, harsh braking, g-sensor, and max speed.
export const soundSources = {
    PowerOn: {
        0: null,
        1: powerOff,
        2: powerChime,
    },
    HighSpeed: {
        0: null,
        1: harshDriving,
        2: harshDrivingChime,
    },
    Accelerometer: {
        0: null,
        1: harshDriving,
        2: harshDrivingChime,
    },
    HarshBraking: {
        0: null,
        1: harshDriving,
        2: harshDrivingChime,
    },
    HarshAccel: {
        0: null,
        1: harshDriving,
        2: harshDrivingChime,
    },
    ForwardCollision: {
        0: null,
        1: FCW_alert,
    },
    Headway: {
        0: null,
        1: headway,
        2: headwayChime,
    },
    FollowingDistance: {
        0: null,
        1: tailgating,
        2: tailgatingChime,
    },
    Distraction: {
        0: null,
        1: distractionDetected,
        2: distractionChime,
    },
    Yawning: {
        0: null,
        1: distractionDetected,
    },
    Dozing: {
        0: null,
        1: distractionDetected,
    },
    PhoneUse: {
        0: null,
        1: distractionDetected,
    },
    Smoking: {
        0: null,
        1: distractionDetected,
    },
    Seatbelt: {
        0: null,
        1: noSeatbeltDetected,
        2: noSeatbeltChime,
    },
    CameraObstruction: {
        0: null,
        1: cameraObstructed,
        2: cameraObstructedChime,
    },
}
